<div id="change-password" fxLayout="column">
  <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div
      id="login-form"
      [class.mat-elevation-z2]="!isActive"
      [class.mat-elevation-z8]="isActive"
    >
      <div class="logo">
        <img
          src="../../assets/heartcare_logo.png"
          style="height: 100px; width: 100px"
        />
      </div>

      <div class="mat-display-2 title mb-30">HeartCare</div>

      <form name="changeForm" [formGroup]="changeForm" novalidate>
        <div style="position: relative">
          <mat-form-field fxFlex="100%" appearance="fill">
            <mat-label class="text-muted">Current password</mat-label>
            <input
              matInput
              formControlName="current_password"
              type="password"
              [(ngModel)]="current_password"
              required
              maxlength="15"
            />
            <mat-error
              *ngIf="changeForm.hasError('required', ['current_password'])"
              >Password id required.</mat-error
            >
          </mat-form-field>
        </div>

        <div style="position: relative">
          <mat-form-field fxFlex="100%" appearance="fill">
            <mat-label class="text-muted">New password</mat-label>
            <input
              matInput
              formControlName="new_password"
              type="password"
              [(ngModel)]="new_password"
              required
              maxlength="15"
            />
            <!-- <mat-hint>
              Min length 8, at least one digit, uppercase, lowercase and special
              character.</mat-hint
            > -->
            <mat-error *ngIf="changeForm.hasError('required', ['new_password'])"
              >Password is required.</mat-error
            >
            <mat-error *ngIf="changeForm.hasError('pattern', ['new_password'])">
              8-15 characters, with at least one special, uppercase, and lowercase character</mat-error
            >
          </mat-form-field>
          <mat-icon
            class="info-icon"
            matTooltip="Password rules :&#13; *Alphanumeric, with at least one special, uppercase, and lowercase character&#13; *Minimum 8 character"
            matTooltipPosition="right"
            matTooltipClass="allow-cr"
            >info</mat-icon
          >
        </div>

        <mat-form-field appearance="fill" style="margin-top: 16px">
          <mat-label class="text-muted">Confirm password</mat-label>
          <input
            matInput
            formControlName="confirm_new_password"
            type="password"
            [(ngModel)]="confirmPassword"
            required
            maxlength="15"
          />
          <mat-error
            *ngIf="changeForm.hasError('changeForm', ['confirm_new_password'])"
            >Please re-enter the password.</mat-error
          >
          <!-- <mat-error *ngIf="changeForm.hasError('pattern', ['confirm_new_password'])">
                              Min length 8, at least one digit, uppercase, lowercase and special character.</mat-error> -->
        </mat-form-field>
        <span
          *ngIf="
            new_password !== confirmPassword &&
            changeForm.get('confirm_new_password')?.dirty &&
            !changeForm.hasError('required', ['confirm_new_password'])
          "
        >
          <div class="reset-display">Passwords do not match</div>
        </span>

        <button
          mat-raised-button
          color="accent"
          class="submit-button mat-body-1"
          aria-label="Change"
          [disabled]="
            disableButton ||
            changeForm.invalid ||
            new_password !== confirmPassword
          "
          (click)="changePassword()"
          color="accent"
        >
          SAVE
        </button>
        <button
          mat-raised-button
          color="disabled"
          type="button"
          class="submit-button mat-body-1"
          (click)="cancel()"
        >
          CANCEL
        </button>
      </form>
    </div>
  </div>
</div>
